import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { doRegister } from '../../services/AuthService';
import { AppButton } from '../../components/AppButton/AppButton';
import AuthLayout from '../../components/Auth/AuthLayout';
import AuthField from '../../components/Auth/AuthField';

const userIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path fillRule="evenodd" d="M8 7a4 4 0 1 1 8 0a4 4 0 0 1-8 0m0 6a5 5 0 0 0-5 5a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3a5 5 0 0 0-5-5z" clipRule="evenodd" />
  </svg>
);

const emailIcon = (
  <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
  </svg>
);

const passwordIcon = (
  <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
  </svg>
);

function Signup() {
  const history = useHistory();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [error, setError] = useState('');

  function onChangeInput(event) {
    if (event.target.id === 'name') setUsername(event.target.value);
    else if (event.target.id === 'email') setEmail(event.target.value);
    else setPassword(event.target.value);
  }

  function onSubmit(event) {
    event.preventDefault();

    if (!acceptedTerms) {
      setError('Please accept the Terms and Conditions and Privacy Policy to create an account.');
      return;
    }

    doRegister(username, email, password)
      .then(() => {
        history.push('/login');
      })
      .catch((err) => {
        console.log(err);
        setError(err?.response?.data?.message || 'Unable to create account. Please try again.');
      });
  }

  return (
    <AuthLayout
      title="Create account"
      description="Start building and running your automated trading strategies."
      footer={(
        <>
          Already have an account?{' '}
          <Link to="/login" className="auth-link">Sign in</Link>
        </>
      )}
    >
      <form onSubmit={onSubmit}>
        <AuthField
          id="name"
          label="Full name"
          type="text"
          placeholder="Your name"
          icon={userIcon}
          autoFocus
          onChange={onChangeInput}
        />
        <AuthField
          id="email"
          label="Email"
          type="email"
          placeholder="you@company.com"
          icon={emailIcon}
          onChange={onChangeInput}
        />
        <AuthField
          id="password"
          label="Password"
          type="password"
          placeholder="Create a password"
          icon={passwordIcon}
          onChange={onChangeInput}
        />

        <label className="auth-checkbox auth-terms-checkbox" htmlFor="accept-terms">
          <input
            type="checkbox"
            id="accept-terms"
            checked={acceptedTerms}
            onChange={(event) => setAcceptedTerms(event.target.checked)}
          />
          <span>
            I agree to the{' '}
            <Link to="/terms-and-conditions" className="auth-link" target="_blank" rel="noopener noreferrer">
              Terms and Conditions
            </Link>
            {' '}and{' '}
            <Link to="/privacy-policy" className="auth-link" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </Link>
          </span>
        </label>

        <AppButton type="submit" variant="primary" size="lg" fullWidth>
          Sign Up
        </AppButton>

        {error && <div className="auth-alert auth-alert-error">{error}</div>}
      </form>
    </AuthLayout>
  );
}

export default Signup;